/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ak as Ak,
  rec_AnaliticaUso as AnaliticaUso,
  rec_Componente_Mk_77_107 as Componente_Mk_77_107,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Sn as Sn,
  rec_Yx as Yx,
  rec_api as api,
  rec_ii as ii,
  rec_pS as pS,
} from "../../runtime/index.jsx";
export function ResumenAdmin() {
  let [e, t] = (0, React.useState)(null),
    [n, r] = (0, React.useState)(!0),
    [i, a] = (0, React.useState)(``),
    o = (0, React.useCallback)(async () => {
      r(!0);
      try {
        (t(await api(`/admin/metricas`)), a(``));
      } catch (e) {
        a(e.message);
      } finally {
        r(!1);
      }
    }, []);
  return (
    (0, React.useEffect)(() => {
      o();
    }, [o]),
    (
      <EstructuraPrincipal
        title={`Resumen general`}
        children={
          <div
            className={`flex flex-col gap-6`}
            children={[
              <EstadoError mensaje={i} onReintentar={o} />,
              n ? (
                <div
                  className={`flex items-center gap-2 text-sm text-(--text)`}
                  children={[
                    (0, JSXRuntime.jsx)(ii, {
                      className: `h-4 w-4 animate-spin`,
                    }),
                    ` Cargando…`,
                  ]}
                />
              ) : i ? null : (
                <JSXRuntime.Fragment
                  children={[
                    <div
                      className={`grid grid-cols-2 gap-3 lg:grid-cols-4`}
                      children={[
                        <Componente_Mk_77_107
                          etiqueta={`Proyectos`}
                          valor={e.totalProyectos}
                          sub={`${e.proyectosActivos} activos`}
                        />,
                        <Componente_Mk_77_107
                          etiqueta={`Tareas`}
                          valor={e.totalTareas}
                        />,
                        <Componente_Mk_77_107
                          etiqueta={`Personas con tareas`}
                          valor={e.totalUsuariosConTareas}
                        />,
                        <Componente_Mk_77_107
                          etiqueta={`Reuniones (7 dias)`}
                          valor={e.reunionesProximas7Dias}
                        />,
                      ]}
                    />,
                    <AnaliticaUso />,
                    <section
                      className={Ak}
                      children={[
                        <p
                          className={`mb-3 font-medium text-(--text-h)`}
                          children={`Tareas por estado (todo el planner)`}
                        />,
                        <ul
                          className={`flex flex-col gap-1.5`}
                          children={Object.entries(e.tareasPorEstado).map(
                            ([e, t]) => (
                              <li
                                key={e}
                                className={`flex items-center justify-between text-sm`}
                                children={[
                                  <span
                                    className={`text-(--text)`}
                                    children={Yx(e)}
                                  />,
                                  <span
                                    className={`font-medium text-(--text-h)`}
                                    children={t}
                                  />,
                                ]}
                              />
                            ),
                          )}
                        />,
                      ]}
                    />,
                    <section
                      className={Ak}
                      children={[
                        <p
                          className={`mb-3 font-medium text-(--text-h)`}
                          children={`Proyectos recientes`}
                        />,
                        <ul
                          className={`flex flex-col gap-1.5`}
                          children={e.proyectosRecientes.map((e) => (
                            <li
                              key={e.id}
                              className={`flex items-center justify-between text-sm`}
                              children={[
                                <Sn
                                  to={`/proyectos/${e.id}`}
                                  className={`text-(--text-h) hover:underline`}
                                  children={e.nombre}
                                />,
                                <span
                                  className={`text-xs text-(--text)`}
                                  children={[
                                    e.miembros,
                                    ` miembros · `,
                                    pS(e.creadoEn),
                                  ]}
                                />,
                              ]}
                            />
                          ))}
                        />,
                      ]}
                    />,
                  ]}
                />
              ),
            ]}
          />
        }
      />
    )
  );
}
